import { createQueryClientWithSentry } from "@repo/common/lib/query-client-sentry";

export const queryClient = createQueryClientWithSentry({
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
  ignoredGraphQlQueryMessages: [
    "Customer not found or is inactive",
    "Estimate not found",
  ],
});
